import * as React from "react";
import styled from "styled-components";

import { Info } from "luxon";

import { Text } from "../../../../components/atoms";
import { theme } from "../../../../theme";

const DatePickerWeekdaysWrapper = styled.div`
  display: flex;
  border-bottom: 0.5px solid ${theme.color.ruubyLightRose};

  ${Text} {
    width: calc(100% / 7);
    text-align: center;
    user-select: none;
  }
`;

export const DatePickerWeekdays: React.FC = () => {
  const sliceEnd = 2;

  return (
    <DatePickerWeekdaysWrapper>
      {Info.weekdays("short").map((weekDay, i) => (
        <Text key={i} weight="semibold">
          {weekDay.slice(0, sliceEnd)}
        </Text>
      ))}
    </DatePickerWeekdaysWrapper>
  );
};
